export default __webpack_public_path__ + "static/media/nanny1.7e4af2ae.jpg";